import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";

import { API } from "./../../config/api";
import "./../Styles/new.css";

export default function Designs() {
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
  const [fileResetKey, setFileResetKey] = useState(Date.now());
  const [uploadPermission, setUploadPermission] = useState("Enabled");
  const [uploadMessage, setUploadMessage] = useState("");

  const [uploadLimit, setUploadLimit] = useState(0);
  const [minimumPrice, setMinimumPrice] = useState(0);
  const [serverCharge, setServerCharge] = useState(0);
  const [serverMessage, setServerMessage] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");

  const topRef = useRef(null);
  const [form, setForm] = useState({
    category: "",
    subcategory: "",
    stitch: "",
    area: "",
    color: "",
    details: "",
    height: "",
    width: "",
    price: "",
    concepts: [],
    jpegFile: null,
    embFile: null,
  });

  const [concepts, setConcepts] = useState([]);
  const [selectedConcepts, setSelectedConcepts] = useState([]);
  const [soldFilter, setSoldFilter] = useState("all");
  const userId = sessionStorage.getItem("userId");
  const [designs, setDesigns] = useState([]);
  const [editData, setEditData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  // Facebook Date Filter
  const [showDateFilter, setShowDateFilter] = useState(false);

  const [dateFilter, setDateFilter] = useState("all");
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [fromDate, setFromDate] = useState("");

  const [toDate, setToDate] = useState("");

  const dateFilterRef = useRef(null);
  const [previewImage, setPreviewImage] = useState("");
  const [selectedFilterCategory, setSelectedFilterCategory] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [successMessage, setSuccessMessage] = useState("");
  const categories = ["Malti", "Sequience", "Cording", "Chain", "Beads"];
  const [selectedFilterSubcategory, setSelectedFilterSubcategory] =
    useState("all");
  const [remainingDays, setRemainingDays] = useState(0);
  const [expiryDate, setExpiryDate] = useState("");
  const [subcategories, setSubcategories] = useState([]);
  const fetchSubcategories = async () => {
    try {
      const res = await fetch(API.LIST_SUBCATEGORY);

      const data = await res.json();

      if (data.status) {
        setSubcategories(data.data);
      } else {
        setSubcategories([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchConcepts = async () => {
    try {
      const res = await fetch(API.CONCEPT_LIST);
      const data = await res.json();

      if (data.status) {
        setConcepts(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSettings = async () => {
    try {
      const res = await fetch(API.GET_SETTINGS);
      const data = await res.json();

      if (data.status) {
        setMinimumPrice(Number(data.data.minimum_design_price));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchUploadPermission = useCallback(async () => {
    try {
      const res = await fetch(API.GET_PROFILE, {
        method: "POST",
        body: new URLSearchParams({
          user_id: userId,
        }),
      });

      const data = await res.json();

      if (data.status && data.data) {
        setUploadPermission(data.data.design_upload_status || "Enabled");
        setUploadMessage(data.data.upload_message || "");
        setUploadLimit(Number(data.data.monthly_upload_limit || 0));
        setRemainingDays(Number(data.data.remaining_days || 0));
        setExpiryDate(data.data.upload_expiry_date || "");
      }
    } catch (err) {
      console.error(err);
    }
  }, [userId]);

  const fetchDesigns = useCallback(async () => {
    try {
      const res = await fetch(
        `${API.BASE_URL}/api.php?action=list_designs_by_user`,
        {
          method: "POST",
          body: new URLSearchParams({ user_id: userId }),
        },
      );

      const text = await res.text();

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("NOT JSON RESPONSE:", text);
        return;
      }

      if (data.status) {
        setDesigns(data.data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  }, [userId]);

  const getDateFilterLabel = () => {
    switch (dateFilter) {
      case "today":
        return "Today";

      case "yesterday":
        return "Yesterday";

      case "last3":
        return "Last 3 Days";

      case "last7":
        return "Last 7 Days";

      case "last15":
        return "Last 15 Days";

      case "last30":
        return "Last 30 Days";

      case "thisMonth":
        return "This Month";

      case "lastMonth":
        return "Last Month";

      case "thisYear":
        return "This Year";

      case "custom":
        return "Custom Range";

      default:
        return "All";
    }
  };
  const getDateRangeText = () => {
    const formatDate = (date) =>
      new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

    const today = new Date();

    let from = new Date();
    let to = new Date();

    switch (dateFilter) {
      case "today":
        from = today;
        break;

      case "yesterday":
        from.setDate(today.getDate() - 1);
        to = new Date(from);
        break;

      case "last3":
        from.setDate(today.getDate() - 3);
        break;

      case "last7":
        from.setDate(today.getDate() - 7);
        break;

      case "last15":
        from.setDate(today.getDate() - 15);
        break;

      case "last30":
        from.setDate(today.getDate() - 30);
        break;

      case "thisMonth":
        from = new Date(today.getFullYear(), today.getMonth(), 1);
        break;

      case "lastMonth":
        from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        to = new Date(today.getFullYear(), today.getMonth(), 0);
        break;

      case "thisYear":
        from = new Date(today.getFullYear(), 0, 1);
        break;

      case "custom":
        if (fromDate && toDate) {
          return `${formatDate(fromDate)} - ${formatDate(toDate)}`;
        }
        return "";

      default:
        return "";
    }
    return `${formatDate(from)} - ${formatDate(to)}`;
  };
  useEffect(() => {
    const today = new Date();

    const from = new Date();
    from.setDate(today.getDate() - 30);

    const formatDate = (date) => date.toISOString().split("T")[0];

    setFromDate(formatDate(from));
    setToDate(formatDate(today));
  }, []);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dateFilterRef.current && !dateFilterRef.current.contains(e.target)) {
        setShowDateFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  /* ================= FILTER & PAGINATION LOGIC ================= */
  // 1. Filter the entire dataset first
  const filteredDesigns = designs.filter((d) => {
    const matchesCategory =
      selectedFilterCategory === "all" || d.category === selectedFilterCategory;
    const matchesSubcategory =
      selectedFilterSubcategory === "all" ||
      String(d.subcategory) === String(selectedFilterSubcategory);
    const matchesSearch = d.design_code
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase());

    const matchesSold =
      soldFilter === "all" ||
      (soldFilter === "sold" && Number(d.sold_times) > 0) ||
      (soldFilter === "unsold" && Number(d.sold_times) === 0);
    const created = new Date(d.created_at);

    const today = new Date();

    today.setHours(0, 0, 0, 0);

    let matchesDate = true;

    switch (dateFilter) {
      case "today": {
        const start = new Date(today);

        const end = new Date(today);

        end.setHours(23, 59, 59, 999);

        matchesDate = created >= start && created <= end;

        break;
      }

      case "yesterday": {
        const start = new Date(today);

        start.setDate(start.getDate() - 1);

        const end = new Date(start);

        end.setHours(23, 59, 59, 999);

        matchesDate = created >= start && created <= end;

        break;
      }

      case "last3":
        matchesDate = created >= new Date(Date.now() - 3 * 86400000);
        break;

      case "last7":
        matchesDate = created >= new Date(Date.now() - 7 * 86400000);
        break;

      case "last15":
        matchesDate = created >= new Date(Date.now() - 15 * 86400000);
        break;

      case "last30":
        matchesDate = created >= new Date(Date.now() - 30 * 86400000);
        break;

      case "thisMonth":
        matchesDate =
          created.getMonth() === today.getMonth() &&
          created.getFullYear() === today.getFullYear();
        break;

      case "lastMonth": {
        const last = new Date();

        last.setMonth(last.getMonth() - 1);

        matchesDate =
          created.getMonth() === last.getMonth() &&
          created.getFullYear() === last.getFullYear();
        break;
      }

      case "thisYear":
        matchesDate = created.getFullYear() === today.getFullYear();
        break;

      case "custom":
        if (fromDate && toDate) {
          const from = new Date(fromDate);

          const to = new Date(toDate);

          to.setHours(23, 59, 59, 999);

          matchesDate = created >= from && created <= to;
        }
        break;

      default:
        matchesDate = true;
    }
    return (
      matchesCategory &&
      matchesSubcategory &&
      matchesSearch &&
      matchesSold &&
      matchesDate
    );
  });

  // 2. Calculate pagination based on the filtered results
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredDesigns.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );
  const totalPages = Math.ceil(filteredDesigns.length / recordsPerPage);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userId) {
      alert("Please login first.");
      return;
    }

    if (!form.jpegFile || !form.embFile) {
      alert("Please select both JPEG and EMB files");
      return;
    }
    if (!form.jpegFile || !form.embFile) {
      alert("Please select both JPEG and EMB files");
      return;
    }

    // Check JPEG size
    if (form.jpegFile.size > MAX_FILE_SIZE) {
      alert("JPEG file size must not be more than 5 MB.");
      return;
    }

    // Check EMB file size
    if (form.embFile.size > MAX_FILE_SIZE) {
      alert("EMB file size must not be more than 5 MB.");
      return;
    }
    if (!form.category) {
      alert("Please select Category");
      return;
    }
    if (!form.subcategory) {
      alert("Please select SubCategory");
      return;
    }
    if (!form.stitch) {
      alert("Please enter Stitch");
      return;
    }
    if (!form.color) {
      alert("Please enter color");
      return;
    }
    if (!form.height) {
      alert("Please enter Height");
      return;
    }
    if (!form.width) {
      alert("Please enter Width");
      return;
    }
    if (!form.price) {
      alert("Please Enter Price");
      return;
    }
    const formData = new FormData();

    // ADD THIS
    formData.append("user_id", userId);

    formData.append("category", form.category);
    formData.append("subcategory", form.subcategory);
    formData.append("stitch", form.stitch);
    formData.append("area", form.area);
    formData.append("color", form.color);
    formData.append("details", form.details);
    formData.append("height", form.height);
    formData.append("width", form.width);
    formData.append("concepts", JSON.stringify(selectedConcepts));
    formData.append("price", form.price);
    formData.append("jpegFile", form.jpegFile);
    formData.append("embFile", form.embFile);

    try {
      const res = await fetch(API.ADD_DESIGN_user, {
        method: "POST",
        body: formData,
      });

      const text = await res.text();

      let data;

      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("Invalid JSON:", text);
        alert(text);
        return;
      }

      if (data.status) {
        fetchDesigns();

        // Reset complete form
        // Clear only file state
        setForm((prev) => ({
          ...prev,
          jpegFile: null,
          embFile: null,
        }));

        // Reset file inputs
        setFileResetKey(Date.now());

        setSuccessMessage("Design added successfully");

        topRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

        setTimeout(() => {
          setSuccessMessage("");
        }, 2000);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("UPLOAD ERROR:", error);
      alert(error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "jpegFile" || name === "embFile") {
      const selectedFile = files[0];

      if (!selectedFile) {
        return;
      }

      if (selectedFile.size > MAX_FILE_SIZE) {
        alert(
          `${name === "jpegFile" ? "JPEG" : "EMB"} file size must not be more than 5 MB.`,
        );

        // Clear the selected file
        setForm((prev) => ({
          ...prev,
          [name]: null,
        }));

        setFileResetKey(Date.now());

        return;
      }

      setForm((prev) => ({
        ...prev,
        [name]: selectedFile,
      }));

      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    if (!userId) {
      alert("Please login first.");
      return;
    }
    // 5 MB file size validation for updated files
    if (
      editData.jpeg_file instanceof File &&
      editData.jpeg_file.size > MAX_FILE_SIZE
    ) {
      alert("JPEG file size must not be more than 5 MB.");
      return;
    }

    if (
      editData.emb_file instanceof File &&
      editData.emb_file.size > MAX_FILE_SIZE
    ) {
      alert("EMB file size must not be more than 5 MB.");
      return;
    }
    const formData = new FormData();

    formData.append("id", editData.id);

    // ADD THIS
    formData.append("user_id", userId);

    formData.append("category", editData.category);
    formData.append("subcategory", editData.subcategory);
    formData.append("stitch", editData.stitch);
    formData.append("area", editData.area);
    formData.append("height", editData.height || "");
    formData.append("width", editData.width || "");
    formData.append("price", editData.price);
    formData.append("color", editData.color);
    formData.append("details", editData.details || "");
    formData.append("concepts", JSON.stringify(editData.concepts_array || []));

    if (editData.jpeg_file instanceof File) {
      formData.append("jpeg_file", editData.jpeg_file);
    }

    if (editData.emb_file instanceof File) {
      formData.append("emb_file", editData.emb_file);
    }

    try {
      const res = await fetch(API.UPDATE_DESIGN_user, {
        method: "POST",
        body: formData,
      });

      const text = await res.text();

      let data;

      try {
        data = JSON.parse(text);
      } catch (e) {
        console.log("Invalid JSON:", text);
        alert(text);
        return;
      }

      alert(data.message);

      if (data.status) {
        setEditData(null);
        fetchDesigns();
      }
    } catch (error) {
      console.error(error);
    }
  };
  // Close popup/modal when Escape key is pressed
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        // Close image preview
        if (previewImage) {
          setPreviewImage("");
        }

        // Close edit modal
        if (editData) {
          setEditData(null);
        }

        // Close payment modal
        if (showPaymentModal) {
          setShowPaymentModal(false);
          setPaymentMethod("");
        }
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [previewImage, editData, showPaymentModal]);
  const handleDownload = async (embFile, userId, designCode) => {
    const url = `${API.DOWNLOAD}?file=${encodeURIComponent(
      `Design_seller/${userId}/${embFile}`,
    )}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        alert("File not found");
        return;
      }

      const blob = await response.blob();

      const extension = embFile.split(".").pop().toLowerCase();

      let downloadName = designCode;

      if (extension === "txt") {
        downloadName += ".emb";
      } else {
        downloadName += "." + extension;
      }

      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = downloadName;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error(err);
      alert("Download failed");
    }
  };
  const handleConceptChange = (conceptId) => {
    let updatedConcepts = [...selectedConcepts];

    if (updatedConcepts.includes(conceptId)) {
      updatedConcepts = updatedConcepts.filter((id) => id !== conceptId);
    } else {
      updatedConcepts.push(conceptId);
    }

    setSelectedConcepts(updatedConcepts);
    setForm({ ...form, concepts: updatedConcepts });
  };

  const handleEditConceptChange = (conceptId) => {
    let updated = [...(editData.concepts_array || [])];

    if (updated.includes(conceptId)) {
      updated = updated.filter((id) => id !== conceptId);
    } else {
      updated.push(conceptId);
    }

    setEditData({
      ...editData,
      concepts_array: updated,
    });
  };
  useEffect(() => {
    fetchConcepts();
    fetchDesigns();
    fetchUploadPermission();
    fetchUploadLimit();
    fetchSubcategories();
    fetchSettings();
  }, [fetchDesigns, fetchUploadPermission]);
  const getSubcategoryName = (id) => {
    const sub = subcategories.find((item) => item.id === id);
    return sub ? sub.name : "-";
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [
    searchTerm,
    selectedFilterCategory,
    selectedFilterSubcategory,
    soldFilter,
    dateFilter,
    fromDate,
    toDate,
  ]);
  const fetchUploadLimit = async () => {
    try {
      const res = await fetch(API.GET_SETTINGS);
      const data = await res.json();

      if (data.status) {
        setUploadLimit(Number(data.data.monthly_design_upload_limit || 0));
      }
    } catch (err) {
      console.log("Upload limit error:", err);
    }
  };
  // const designUploadStats = useMemo(() => {
  //   const today = new Date();

  //   const last7 = new Date();
  //   last7.setDate(today.getDate() - 7);

  //   const last30 = new Date();
  //   last30.setDate(today.getDate() - 30);

  //   return {
  //     total: designs.length,

  //     last7: designs.filter((d) => new Date(d.created_at) >= last7).length,

  //     last30: designs.filter((d) => new Date(d.created_at) >= last30).length,
  //   };
  // }, [designs]);

  const designUploadStats = useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const last7 = new Date();
    last7.setDate(last7.getDate() - 7);

    const last30 = new Date();
    last30.setDate(last30.getDate() - 30);

    return {
      total: designs.length,

      today: designs.filter((d) => {
        const created = new Date(d.created_at);
        return created >= today && created < tomorrow;
      }).length,

      last7: designs.filter((d) => new Date(d.created_at) >= last7).length,

      last30: designs.filter((d) => new Date(d.created_at) >= last30).length,
    };
  }, [designs]);
  const payServerCharge = async () => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    if (!loginUser) return;

    const res = await fetch(
      `${API.BASE_URL}/payment.php?action=create_server_charge_order`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: loginUser.id,
        }),
      },
    );

    const data = await res.json();

    if (!data.success) {
      alert(data.message);
      return;
    }

    const options = {
      key: data.key,

      amount: data.amount,

      currency: "INR",

      name: "Server Charges",

      description: "Designer Server Charges",

      order_id: data.order_id,

      handler: function (response) {
        saveServerPayment(response);
      },

      modal: {
        ondismiss: function () {
          saveCancelledPayment(data.order_id);
        },
      },

      prefill: {
        name: data.name,
        email: data.email,
        contact: data.phone,
      },

      theme: {
        color: "#0d51cf",
      },
    };

    const razor = new window.Razorpay(options);

    razor.on("payment.failed", function () {
      setServerMessage("Payment failed. Please try again.");
    });

    razor.open();
  };

  const saveServerPayment = async (response) => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    const res = await fetch(
      `${API.BASE_URL}/payment.php?action=verify_server_charge_payment`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          razorpay_payment_id: response.razorpay_payment_id,

          razorpay_order_id: response.razorpay_order_id,

          user_id: loginUser.id,
        }),
      },
    );

    const data = await res.json();

    if (data.success) {
      setServerMessage("Server charge payment successful.");
    } else {
      setServerMessage("Payment verification failed.");
    }
  };

  const saveCancelledPayment = async (order_id) => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    await fetch(`${API.BASE_URL}/payment.php?action=cancel_server_charge`, {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        user_id: loginUser.id,

        order_id,
      }),
    });

    setServerMessage("Payment cancelled by user.");
  };

  useEffect(() => {
    const loadServerCharge = async () => {
      try {
        const res = await fetch(
          `${API.BASE_URL}/payment.php?action=server_charge_amount`,
        );

        const data = await res.json();

        if (data.success) {
          setServerCharge(Number(data.amount));
        }
      } catch (err) {
        console.log(err);
      }
    };

    loadServerCharge();
  }, []);
  return (
    <div className="ad-container">
      <div ref={topRef}></div>
      <div className="ad-header">
        {uploadPermission === "Disabled" && (
          <div className="upload-disabled-alert">
            <div className="upload-disabled-icon">
              <i className="bi bi-exclamation-triangle-fill"></i>
            </div>

            <div className="upload-disabled-content">
              <h6>Design Upload Disabled</h6>

              <p>{uploadMessage}</p>

              {/* <div className="upload-contact">
                <i className="bi bi-telephone-fill"></i>
                <span>Contact Us: +91 9909614445</span>
              </div> */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="upload-contact">
                  <i className="bi bi-telephone-fill"></i>
                  <span>Contact Us: +91 9909614445</span>
                </div>
                <div>
                  {/* <button className="btn btn-success" onClick={payServerCharge}>
                    Pay Server Charges ₹{serverCharge}
                  </button> */}
                  <button
                    className="btn btn-success"
                    onClick={() => setShowPaymentModal(true)}
                  >
                    Pay Server Charges ₹{serverCharge}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {serverMessage && (
          <div className="alert alert-info mt-3">{serverMessage}</div>
        )}

        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <h2 className="ad-title mb-0">Design Upload</h2>

          {expiryDate && (
            <div
              className={`d-flex align-items-center px-3 py-1 rounded-pill ${
                remainingDays < 0
                  ? "bg-danger text-white"
                  : remainingDays <= 3
                    ? "bg-warning text-dark"
                    : "bg-light text-secondary border"
              }`}
              style={{
                fontSize: "13px",
                fontWeight: 600,
              }}
            >
              <i
                className={`bi me-2 ${
                  remainingDays < 0
                    ? "bi-x-circle-fill"
                    : remainingDays <= 3
                      ? "bi-exclamation-triangle-fill"
                      : "bi-clock-history"
                }`}
              ></i>

              {remainingDays > 3 && <>Plan expires in {remainingDays} days</>}

              {remainingDays === 3 && <>Only 3 days remaining</>}

              {remainingDays === 2 && <>Only 2 days remaining</>}

              {remainingDays === 1 && <>Expires Tomorrow</>}

              {remainingDays === 0 && <>Expires Today</>}

              {remainingDays < 0 && <>Plan Expired</>}
            </div>
          )}
        </div>
        <p className="ad-subtitle">
          Create and manage your embroidery design patterns
        </p>
        {successMessage && (
          <div className="alert alert-success shadow-sm">
            <i className="bi bi-check-circle-fill me-2"></i>
            {successMessage}
          </div>
        )}
      </div>

      {/* FORM SECTION */}
      <div className="ad-form-card">
        <fieldset disabled={uploadPermission === "Disabled"}>
          <form onSubmit={handleSubmit} className="ad-form">
            <div
              className="border-box"
              style={{
                border: "1px solid #495057 ",
                padding: "35px",
                boxShadow: "inset 0 0 0 1px #495057",
                borderRadius: "5px",
              }}
            >
              <h2 className="ad-card-title">
                <i className="bi bi-plus-circle me-2"></i>Add New Design
              </h2>
              <div className="row g-3">
                <div className="ad-form-compact">
                  <div className="ad-row">
                    <label>Category</label>
                    <div className="ad-input-box">
                      <select
                        name="category"
                        value={form.category}
                        onChange={handleChange}
                      >
                        <option value="">Select Category</option>
                        {categories.map((cat) => (
                          <option key={cat}>{cat}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="ad-row">
                    <label>Sub Category</label>

                    <div className="ad-input-box">
                      <select
                        name="subcategory"
                        value={form.subcategory}
                        onChange={handleChange}
                      >
                        <option value="">Select Subcategory</option>

                        {subcategories.map((sub) => (
                          <option key={sub.id} value={sub.id}>
                            {sub.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="ad-row">
                    <label>Stitch Count</label>
                    <div className="ad-input-box">
                      <input
                        name="stitch"
                        value={form.stitch}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="ad-row">
                    <label>Height</label>
                    <div className="ad-input-box">
                      <input
                        name="height"
                        value={form.height}
                        onChange={handleChange}
                        placeholder="Enter height"
                      />
                    </div>
                  </div>
                  <div className="ad-row">
                    <label>Width</label>
                    <div className="ad-input-box">
                      <input
                        name="width"
                        value={form.width}
                        onChange={handleChange}
                        placeholder="Enter width"
                      />
                    </div>
                  </div>

                  <div className="ad-row">
                    <label>Color</label>
                    <div className="ad-input-box">
                      <input
                        name="color"
                        value={form.color}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="ad-row">
                    <label>Area</label>
                    <div className="ad-input-box">
                      <input
                        name="area"
                        value={form.area}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="ad-row">
                    <label>
                      Price
                      {minimumPrice > 0 && (
                        <small className="text-danger ms-2">
                          (Minimum ₹{minimumPrice})
                        </small>
                      )}
                    </label>
                    <div className="ad-input-box">
                      <input
                        type="number"
                        name="price"
                        value={form.price}
                        min={minimumPrice}
                        onChange={handleChange}
                      />

                      {form.price !== "" &&
                        Number(form.price) < minimumPrice && (
                          <small className="text-danger">
                            Minimum price is ₹{minimumPrice}
                          </small>
                        )}
                    </div>
                  </div>

                  <div className="ad-row">
                    <label>JPEG</label>
                    <div className="ad-input-box">
                      <input
                        key={`jpg-${fileResetKey}`}
                        type="file"
                        name="jpegFile"
                        onChange={handleChange}
                        accept="image/jpeg,image/jpg"
                      />
                    </div>
                  </div>

                  <div className="ad-row">
                    <label>EMB</label>
                    <div className="ad-input-box">
                      <input
                        key={`emb-${fileResetKey}`}
                        type="file"
                        name="embFile"
                        accept=".emb,.zip,.rar"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="ad-row">
                    <label>Details</label>

                    <div className="ad-input-box">
                      <input
                        type="text"
                        name="details"
                        placeholder="Enter design details..."
                        value={form.details}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="ad-label mb-0">Concepts</label>
                  </div>

                  <div className="concept-grid-container">
                    {categories.map((category) => {
                      const filtered = concepts.filter(
                        (c) => c.category === category,
                      );

                      if (filtered.length === 0) return null;

                      return (
                        <div key={category} className="colum">
                          {/* Category Title */}
                          <h6 className="fw-bold mb-2">{category}</h6>

                          {/* Horizontal Row */}
                          <div className="concept-row">
                            {filtered.map((concept) => (
                              <label
                                key={concept.id}
                                className="concept-custom-checkbox"
                              >
                                <input
                                  type="checkbox"
                                  checked={selectedConcepts.includes(
                                    concept.id,
                                  )}
                                  onChange={() =>
                                    handleConceptChange(concept.id)
                                  }
                                />
                                <span className="concept-checkmark"></span>
                                <span className="concept-label-text">
                                  {concept.concept_name}
                                </span>
                              </label>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="col-12">
                  <button type="submit" className="ad-btn-submit">
                    <i className="bi bi-cloud-arrow-up me-2"></i>Save Design
                  </button>
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      </div>

      <hr className="ad-divider" />

      <div className="design-upload-summary-row">
        {/* Summary Stat Cards */}
        {/* <div className="summary-cards-group">
          <div className="design-summary-card">
            <span className="card-label">Total Designs</span>
            <h3 className="card-value">{designUploadStats.total}</h3>
          </div>

          <div className="design-summary-card">
            <span className="card-label">Last 7 Days</span>
            <h3 className="card-value">{designUploadStats.last7}</h3>
          </div>

          <div className="design-summary-card">
            <span className="card-label">Last 30 Days</span>

            <h3 className="card-value">
              {designUploadStats.last30}
              <small className="upload-limit-text">/ {uploadLimit}</small>
            </h3>
          </div>

        </div> */}

        <div className="summary-cards-group">
          <div className="design-summary-card">
            <span className="card-label">Total Designs</span>
            <h3 className="card-value">{designUploadStats.total}</h3>
          </div>

          <div className="design-summary-card">
            <span className="card-label">Today's Upload</span>
            <h3 className="card-value">{designUploadStats.today}</h3>
          </div>

          <div className="design-summary-card">
            <span className="card-label">Last 7 Days</span>
            <h3 className="card-value">{designUploadStats.last7}</h3>
          </div>

          <div className="design-summary-card">
            <span className="card-label">Last 30 Days</span>
            <h3 className="card-value">
              {designUploadStats.last30}
              <small className="upload-limit-text"> / {uploadLimit}</small>
            </h3>
          </div>
        </div>

        {/* Date Filter Dropdown */}
        <div className="fb-date-filter" ref={dateFilterRef}>
          <button
            type="button"
            className="fb-date-btn"
            onClick={() => setShowDateFilter(!showDateFilter)}
          >
            <div className="fb-date-left">
              <i className="bi bi-calendar3"></i>
              <div className="fb-date-text">
                <span>{getDateFilterLabel()}</span>
                {getDateRangeText() && (
                  <small className="fb-date-range">
                    ({getDateRangeText()})
                  </small>
                )}
              </div>
            </div>
            <i
              className={`bi ${showDateFilter ? "bi-chevron-up" : "bi-chevron-down"}`}
            ></i>
          </button>

          {showDateFilter && (
            <div className="fb-date-dropdown">
              {/* Preset Options Column */}
              <div className="fb-left">
                {[
                  { id: "all", label: "All" },
                  { id: "today", label: "Today" },
                  { id: "yesterday", label: "Yesterday" },
                  { id: "last3", label: "Last 3 Days" },
                  { id: "last7", label: "Last 7 Days" },
                  { id: "last15", label: "Last 15 Days" },
                  { id: "last30", label: "Last 30 Days" },
                  { id: "thisMonth", label: "This Month" },
                  { id: "lastMonth", label: "Last Month" },
                  { id: "thisYear", label: "This Year" },
                ].map((option) => (
                  <div
                    key={option.id}
                    className={`fb-date-item ${dateFilter === option.id ? "active" : ""}`}
                    onClick={() => {
                      setDateFilter(option.id);
                      setShowDateFilter(false);
                    }}
                  >
                    {option.label}
                  </div>
                ))}
              </div>

              {/* Custom Date Range Column */}
              <div className="fb-right">
                <div className="fb-custom-title">Custom Date Range</div>
                <div className="fb-custom-range">
                  <div className="input-group">
                    <label>From</label>
                    <input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>
                  <div className="input-group">
                    <label>To</label>
                    <input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                </div>

                <div className="fb-custom-buttons">
                  <button
                    type="button"
                    className="fb-btn-cancel"
                    onClick={() => {
                      setFromDate("");
                      setToDate("");
                      setDateFilter("last30");
                      setShowDateFilter(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="fb-btn-apply"
                    onClick={() => {
                      if (fromDate && toDate) {
                        setDateFilter("custom");
                      }
                      setShowDateFilter(false);
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* FILTER SECTION */}
      <div className="ad-filter-bar">
        <div className="ad-filter-controls">
          <select
            className="ad-input w-auto"
            value={selectedFilterCategory}
            onChange={(e) => setSelectedFilterCategory(e.target.value)}
          >
            <option value="all">All Categories</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
          <select
            className="ad-input w-auto"
            value={selectedFilterSubcategory}
            onChange={(e) => setSelectedFilterSubcategory(e.target.value)}
          >
            <option value="all">All Subcategories</option>

            {subcategories.map((sub) => (
              <option key={sub.id} value={sub.id}>
                {sub.name}
              </option>
            ))}
          </select>
          <select
            className="ad-input w-auto"
            value={soldFilter}
            onChange={(e) => setSoldFilter(e.target.value)}
          >
            <option value="all">All Designs</option>
            <option value="sold">Sold</option>
            <option value="unsold">Unsold</option>
          </select>
          <div className="ad-search-wrapper">
            <i className="bi bi-search"></i>
            <input
              type="text"
              className="ad-input ad-search-input"
              placeholder="Search code..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <select
            className="ad-input w-auto"
            value={recordsPerPage}
            onChange={(e) => {
              setRecordsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={20}>20 Designs</option>

            <option value={40}>40 Designs</option>
            <option value={60}>60 Designs</option>
            <option value={80}>80 Designs</option>
          </select>
        </div>

        <h4 className="ad-card-title mb-0">Designs List</h4>
      </div>

      {/* TABLE SECTION */}
      <div className="ad-table-responsive">
        <table className="ad-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Image</th>
              {/* <th>Category</th> */}
              <th>Details</th>
              <th>Size</th>
              <th>Price</th>
              <th>Sold</th>
              {/* <th>Details</th> */}
              <th>Concept</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentRecords.length > 0 ? (
              currentRecords.map((design, index) => (
                <tr key={design.id}>
                  <td>
                    {filteredDesigns.length - (indexOfFirstRecord + index)}
                  </td>
                  <td>
                    {design.created_at
                      ? new Date(design.created_at).toLocaleDateString(
                          "en-IN",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          },
                        )
                      : "-"}
                  </td>
                  <td>
                    {/* <img
                      src={`${API.BASE_URL}/uploads/Design_seller/${design.user_id}/jpg/${design.jpeg_file}`}
                      alt={design.design_code}
                      className="ad-table-img"
                    /> */}
                    <img
                      src={`${API.BASE_URL}/uploads/Design_seller/${design.user_id}/${design.jpeg_file}`}
                      alt={design.design_code}
                      className="ad-table-img"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setPreviewImage(
                          `${API.BASE_URL}/uploads/Design_seller/${design.user_id}/${design.jpeg_file}`,
                        )
                      }
                    />
                  </td>
                  {/* <td>
                    {design.created_at
                      ? new Date(design.created_at).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : "-"}
                  </td> */}

                  {/* <td>
                    <div
                      className="gap-1 "
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    ></div>
                  </td> */}
                  <td>
                    <div
                      className="gap-1 "
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span className="tag">
                        <strong>Code:</strong> {design.design_code}
                      </span>
                      <span className="tag">
                        <strong>Category:</strong> {design.category}
                      </span>

                      <span className="tag">
                        <strong>Sub: </strong>
                        {getSubcategoryName(design.subcategory)}
                      </span>

                      <span className="tag">
                        <strong>Colors:</strong> {design.color || "-"}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div
                      className="gap-1 "
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span className="tag">
                        <strong>Height:</strong> {design.height}
                      </span>

                      <span className="tag">
                        <strong>Width: </strong>
                        {design.width || 0}
                      </span>
                      <span className="tag">
                        <strong>Area: </strong>
                        {design.area || 0}
                      </span>
                      <span className="tag">
                        <strong>Stitches: </strong>
                        {design.stitch || 0}
                      </span>
                    </div>
                  </td>
                  <td>{design.price}</td>
                  <td className="text-center">
                    <span
                      className={`badge ${
                        Number(design.sold_times) > 0
                          ? "bg-success"
                          : "bg-secondary"
                      }`}
                    >
                      {design.sold_times}{" "}
                      {/* {Number(design.sold_times) === 1 ? "Time" : "Times"} */}
                    </span>
                  </td>

                  {/* <td>{design.details}</td> */}
                  <td>
                    {design.concepts_array
                      ?.map((id) => {
                        const concept = concepts.find((c) => c.id === id);
                        return concept ? concept.concept_name : null;
                      })
                      .filter(Boolean)
                      .join(", ")}
                  </td>
                  <td>
                    <div className="ad-action-btns">
                      <button
                        className="ad-icon-btn ad-edit"
                        title="Edit"
                        onClick={() => setEditData(design)}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button>
                      {/* <button
                        className="ad-icon-btn ad-delete"
                        title="Delete"
                        onClick={() => handleDelete(design.id)}
                      >
                        <i className="bi bi-trash3"></i>
                      </button> */}
                      <button
                        className="ad-icon-btn ad-download"
                        title="Download EMB"
                        onClick={() =>
                          handleDownload(
                            design.emb_file,
                            design.user_id,
                            design.design_code,
                          )
                        }
                      >
                        <i className="bi bi-download"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="12" className="text-center py-4">
                  No designs found matching your search.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION CONTROLS */}
      {/* PAGINATION */}
      {totalPages > 1 && (
        <div className="ad-pagination-container">
          <button
            className="ad-page-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            <i className="bi bi-chevron-left"></i>
          </button>

          {(() => {
            const pages = [];

            if (totalPages <= 7) {
              for (let i = 1; i <= totalPages; i++) {
                pages.push(
                  <button
                    key={i}
                    className={`ad-page-number ${
                      currentPage === i ? "active" : ""
                    }`}
                    onClick={() => setCurrentPage(i)}
                  >
                    {i}
                  </button>,
                );
              }
            } else {
              // Always show first 5 pages
              if (currentPage <= 5) {
                for (let i = 1; i <= 5; i++) {
                  pages.push(
                    <button
                      key={i}
                      className={`ad-page-number ${
                        currentPage === i ? "active" : ""
                      }`}
                      onClick={() => setCurrentPage(i)}
                    >
                      {i}
                    </button>,
                  );
                }

                pages.push(
                  <span key="dots1" className="ad-page-dots">
                    ...
                  </span>,
                );

                pages.push(
                  <button
                    key={totalPages}
                    className={`ad-page-number ${
                      currentPage === totalPages ? "active" : ""
                    }`}
                    onClick={() => setCurrentPage(totalPages)}
                  >
                    {totalPages}
                  </button>,
                );
              }

              // Middle pages
              else if (currentPage > 5 && currentPage < totalPages - 3) {
                pages.push(
                  <button
                    key={1}
                    className="ad-page-number"
                    onClick={() => setCurrentPage(1)}
                  >
                    1
                  </button>,
                );

                pages.push(
                  <span key="dots1" className="ad-page-dots">
                    ...
                  </span>,
                );

                for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                  pages.push(
                    <button
                      key={i}
                      className={`ad-page-number ${
                        currentPage === i ? "active" : ""
                      }`}
                      onClick={() => setCurrentPage(i)}
                    >
                      {i}
                    </button>,
                  );
                }

                pages.push(
                  <span key="dots2" className="ad-page-dots">
                    ...
                  </span>,
                );

                pages.push(
                  <button
                    key={totalPages}
                    className="ad-page-number"
                    onClick={() => setCurrentPage(totalPages)}
                  >
                    {totalPages}
                  </button>,
                );
              }

              // Last pages
              else {
                pages.push(
                  <button
                    key={1}
                    className="ad-page-number"
                    onClick={() => setCurrentPage(1)}
                  >
                    1
                  </button>,
                );

                pages.push(
                  <span key="dots1" className="ad-page-dots">
                    ...
                  </span>,
                );

                for (let i = totalPages - 4; i <= totalPages; i++) {
                  pages.push(
                    <button
                      key={i}
                      className={`ad-page-number ${
                        currentPage === i ? "active" : ""
                      }`}
                      onClick={() => setCurrentPage(i)}
                    >
                      {i}
                    </button>,
                  );
                }
              }
            }

            return pages;
          })()}

          <button
            className="ad-page-btn"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>
      )}
      {/* EDIT MODAL */}
      {editData && (
        <div className="ad-modal-overlay">
          <div className="ad-modal-content">
            <div className="ad-modal-header">
              <h4>Update Design Details</h4>
              <button
                className="btn-close"
                onClick={() => setEditData(null)}
              ></button>
            </div>
            <div className="ad-modal-body">
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="ad-label">Category</label>
                  <select
                    className="ad-input"
                    value={editData.category}
                    onChange={(e) =>
                      setEditData({ ...editData, category: e.target.value })
                    }
                  >
                    {categories.map((cat) => (
                      <option key={cat}>{cat}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="ad-label">Sub Category</label>

                  <select
                    className="ad-input"
                    value={editData.subcategory || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        subcategory: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Subcategory</option>

                    {subcategories.map((sub) => (
                      <option key={sub.id} value={sub.id}>
                        {sub.name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="col-md-4">
                  <label className="ad-label">Design Code</label>
                  <input
                    className="ad-input"
                    value={editData.design_code}
                    onChange={(e) =>
                      setEditData({ ...editData, design_code: e.target.value })
                    }
                  />
                </div> */}

                <div className="col-md-4">
                  <label className="ad-label">Price</label>
                  <input
                    className="ad-input"
                    value={editData.price}
                    onChange={(e) =>
                      setEditData({ ...editData, price: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label className="ad-label">Stitch</label>
                  <input
                    className="ad-input"
                    value={editData.stitch}
                    onChange={(e) =>
                      setEditData({ ...editData, stitch: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label className="ad-label">Area</label>
                  <input
                    className="ad-input"
                    value={editData.area}
                    onChange={(e) =>
                      setEditData({ ...editData, area: e.target.value })
                    }
                  />
                </div>

                <div className="col-md-4">
                  <label className="ad-label">Height</label>
                  <input
                    className="ad-input"
                    value={editData.height}
                    onChange={(e) =>
                      setEditData({ ...editData, height: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label className="ad-label">Width</label>
                  <input
                    className="ad-input"
                    value={editData.width}
                    onChange={(e) =>
                      setEditData({ ...editData, width: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label className="ad-label">Color</label>
                  <input
                    className="ad-input"
                    value={editData.color}
                    onChange={(e) =>
                      setEditData({ ...editData, color: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-12">
                  <label className="ad-label">Details</label>
                  <textarea
                    className="ad-input"
                    rows="3"
                    value={editData.details || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        details: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-md-12">
                  <label className="ad-label">Concepts</label>

                  <div className="concept-grid-container">
                    {categories.map((category) => {
                      const filtered = concepts.filter(
                        (c) => c.category === category,
                      );

                      if (filtered.length === 0) return null;

                      return (
                        <div key={category} className="colum">
                          {/* Category Title */}
                          <h6 className="fw-bold mb-2">{category}</h6>

                          {/* Horizontal Row */}
                          <div className="concept-row">
                            {filtered.map((concept) => (
                              <label
                                key={concept.id}
                                className="concept-custom-checkbox"
                              >
                                <input
                                  type="checkbox"
                                  checked={editData.concepts_array?.includes(
                                    concept.id,
                                  )}
                                  onChange={() =>
                                    handleEditConceptChange(concept.id)
                                  }
                                />
                                <span className="concept-checkmark"></span>
                                <span className="concept-label-text">
                                  {concept.concept_name}
                                </span>
                              </label>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="col-md-12">
                  <label className="ad-label">Update JPEG</label>
                  <input
                    type="file"
                    className="ad-input"
                    accept="image/jpeg,image/jpg"
                    onChange={(e) => {
                      const file = e.target.files[0];

                      if (!file) return;

                      if (file.size > MAX_FILE_SIZE) {
                        alert("JPEG file size must not be more than 5 MB.");
                        e.target.value = "";
                        return;
                      }

                      setEditData({
                        ...editData,
                        jpeg_file: file,
                      });
                    }}
                  />
                </div>

                <div className="col-md-12">
                  <label className="ad-label">Update EMB</label>
                  <input
                    type="file"
                    className="ad-input"
                    accept=".emb,.zip,.rar"
                    onChange={(e) => {
                      const file = e.target.files[0];

                      if (!file) return;

                      if (file.size > MAX_FILE_SIZE) {
                        alert("EMB file size must not be more than 5 MB.");
                        e.target.value = "";
                        return;
                      }

                      setEditData({
                        ...editData,
                        emb_file: file,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="ad-modal-footer">
              <button
                className="ad-btn-cancel"
                onClick={() => setEditData(null)}
              >
                Close
              </button>
              <button className="ad-btn-submit" onClick={handleUpdate}>
                Update Changes
              </button>
            </div>
          </div>
        </div>
      )}
      {previewImage && (
        <div className="preview-modal" onClick={() => setPreviewImage("")}>
          <div
            className="preview-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="preview-close"
              onClick={() => setPreviewImage("")}
            >
              &times;
            </button>

            <img src={previewImage} alt="Preview" />
          </div>
        </div>
      )}
      {showPaymentModal && (
        <div className="ad-modal-overlay">
          <div
            className="ad-modal-content p-3"
            style={{ maxWidth: "450px", textAlign: "center" }}
          >
            <div className="ad-modal-header pb-3 m-0">
              <h4 className="mb-0">Select Payment Method</h4>

              <button
                className="btn-close-custom"
                onClick={() => {
                  setShowPaymentModal(false);
                  setPaymentMethod("");
                }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            <div className="ad-modal-body p-0">
              {!paymentMethod && (
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className="btn btn-light"
                    onClick={() => setPaymentMethod("gpay")}
                  >
                    <img
                      src="/images/gpay.png"
                      alt="Google Pay"
                      style={{ width: "120px", height: "60px" }}
                    />
                  </button>
                  <button
                    className="btn btn-light"
                    onClick={() => {
                      setShowPaymentModal(false);
                      payServerCharge();
                    }}
                  >
                    <img
                      src="/images/razorpay.png"
                      alt="Razorpay"
                      style={{ width: "120px", height: "60px" }}
                    />
                  </button>
                </div>
              )}
              {paymentMethod === "gpay" && (
                <div className="text-center mt-4">
                  <p className="mt-3 fw-bold" style={{ fontSize: "13px" }}>
                    Scan using Google Pay
                  </p>
                  <img
                    src="/images/qr.jpeg"
                    alt="Google Pay QR"
                    className="payment-qr"
                  />
                  <p className="mt-3 fw-bold">
                    Amount: <strong>₹{serverCharge}</strong>
                  </p>

                  <p className="mt-3 text-danger fw-bold">
                    After Payment Send Screenshot And Call on <br /> +91
                    9909614445{" "}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
